import { render, staticRenderFns } from "./QnaListView.vue?vue&type=template&id=33b6f202&scoped=true&"
import script from "./QnaListView.vue?vue&type=script&lang=js&"
export * from "./QnaListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6f202",
  null
  
)

export default component.exports